import React, { FunctionComponent } from "react"
import s from "./ProgressBar.less"

interface iProps {
  progress: number
}

const ProgressBar: FunctionComponent<iProps> = ({ progress }) => {
  return (
    <div className={s.progress}>
      <div className={s.bar} style={{ width: (progress || 0) + "%" }}></div>
    </div>
  )
}

export default ProgressBar
